import React, { Component } from "react";
import { ICONS, SvgIcon } from "../Common/Icons";
import { Select, Option } from "../UI/form";
import _ from "i18n";
import styles from "./SlideCompositionPage.local.scss";
import inputStyles from "../Common/InputsLanguages/inputsLanguages.local.scss";

import { connect } from "react-redux";

class SlideConfigurationPage extends Component {
  render() {
    return (
      <div>
        <div>
          <SvgIcon icon={ICONS.SETTING} className={styles.config_icon} />
          <div className={styles.config_text}>
            {_("slideConfigurationPage")}
          </div>
        </div>

        <div className={inputStyles.slide_title}>
          <div className={inputStyles.labels_form_block}>
            <span className={inputStyles.span_label}>
              <img src={"/img/icons/fr_flag.png"} alt={""} width={22} />
              {_("French")}
            </span>
            <div className={inputStyles.div_input}>
              <input
                type={"text"}
                placeholder={_("frTitle")}
                value={this.props.slideLabel.fr}
                onChange={e => this.props.HandleInputChange("fr", e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </div>
            <span className={inputStyles.span_label}>
              <img src={"/img/icons/en_flag.png"} alt={""} width={22} />
              {_("English")}
            </span>
            <div className={inputStyles.div_input}>
              <input
                type={"text"}
                placeholder={_("enTitle")}
                value={this.props.slideLabel.en}
                onChange={e => this.props.HandleInputChange("en", e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </div>
            <span className={inputStyles.span_label}>
              <img src={"/img/icons/nl_flag.png"} alt={""} width={22} />
              {_("Dutch")}
            </span>
            <div className={inputStyles.div_input}>
              <input
                type={"text"}
                placeholder={_("nlTitle")}
                value={this.props.slideLabel.nl}
                onChange={e => this.props.HandleInputChange("nl", e)}
                required={true}
              />
              <img src={"/img/icons/pencil.svg"} alt={""} />
            </div>
          </div>
        </div>
        <div
          className={`row`}
          style={{ marginLeft: "31px", marginTop: "20px" }}
        >
          <div className={`large-6 medium-6 small-6`}>
            <div className={styles.select_label}>
              {_("slideBackgroundColor")}
            </div>
            <Select
              onChange={this.props.handleChangeFondColor}
              className={styles.select_option}
              value={this.props.colorsConfig.background}
            >
              <Option value="#FFFFFF" key="0">
                {_("white")}
              </Option>
              <Option value="#F3FAFF" key="1">
                {_("bleu")}
              </Option>
            </Select>
          </div>
          <div className={`large-6 medium-6 small-6`}>
            <div className={styles.select_label}>
              {_("slideComponentColor")}
            </div>
            <Select
              className={styles.select_option}
              onChange={this.props.handleChangeComponentBackgroundColor}
              value={this.props.colorsConfig.componentsBackground}
            >
              <Option value="#FFFFFF" key="0">
                {_("white")}
              </Option>
              <Option value="#F3FAFF" key="1">
                {_("bleu")}
              </Option>
            </Select>
          </div>
        </div>
        <div className={styles.layout_disposition}>
          <div className={styles.layout_title}>{_("slideLayoutTitle")}</div>
          <div className={`row`} style={{ marginTop: "10px" }}>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_1")}
              >
                <img src={`/img/slide-composition/Layout1.svg`} alt={""} />
              </button>
            </div>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_6")}
              >
                <img src={`/img/slide-composition/Layout6.svg`} alt={""} />
              </button>
            </div>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_7")}
              >
                <img src={`/img/slide-composition/Layout7.svg`} alt={""} />
              </button>
            </div>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_3")}
              >
                <img src={`/img/slide-composition/Layout3.svg`} alt={""} />
              </button>
            </div>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_2")}
              >
                <img src={`/img/slide-composition/Layout2.svg`} alt={""} />
              </button>
            </div>
            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_5")}
              >
                <img src={`/img/slide-composition/Layout5.svg`} alt={""} />
              </button>
            </div>

            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_8")}
              >
                <img src={`/img/slide-composition/Layout8.svg`} alt={""} />
              </button>
            </div>

            <div className={`large-6 medium-6 small-12`}>
              <button
                className={styles.layout}
                onClick={() => this.props.HandleLayoutChange("LAYOUT_9")}
              >
                <img src={`/img/slide-composition/Layout9.svg`} alt={""} />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  slideLabel: state.slideComposition.composition.labels
});

export default connect(mapStateToProps)(SlideConfigurationPage);



// WEBPACK FOOTER //
// ./src/components/SlideComposition/SlideConfigurationPage.js